import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

// Селекторы для получения состояния Redux
const isLoadingSelector = (state: RootState) => state.auth.isLoading;
const isCodeSelector = (state: RootState) => state.auth.code;
const isLoginErrorSelector = (state: RootState) => state.auth.errors.login;
const isSignUpErrorSelector = (state: RootState) => state.auth.errors.signUp;

// Создание селекторов
export const selectIsLoadingAuth = createSelector(isLoadingSelector, isLoading => isLoading);
export const selectIsCodeAuth = createSelector(isCodeSelector, code => code);
export const selectIsLoginErrorAuth = createSelector(isLoginErrorSelector, error => error || '');
export const selectIsSignUpErrorAuth = createSelector(isSignUpErrorSelector, error => error || '');
